export const getMaintenaceSessionId = function(params) {
    let url = `/api/form/${params.brandId}/service/session?visitor_id=${params.visitorId}`;
    if (params.dealerId) {
        url=`${url}&dealer=${params.dealerId}`
    }

    return url;
};



// WEBPACK FOOTER //
// ./src/urlConstructor/initMaintenanceSession.js